import React from "react"
import styled from "styled-components"
import {GroupCelebration, GroupCelebrationStatus} from "@irati/types"
import {Body, H2} from "@irati/ui/src/Typography"
import addMessageSuccess from "../../../images/addMessage.svg"
import {injectIntl, InjectIntlProps} from "@irati/utils/lang/injectIntl"
import Flex from "@irati/ui/src/Flex"
import tracking from "@irati-tracking/recognition/recognition"
import FormattedMessage, {FormattedRelative, useIntl} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {ProfilePicContainer, CelebrationIcon} from "../../Polls/ClosedPoll/styled"
import ProfilePicGroup, {DEFAULT_MULTIPLE_PICTURE_SIZE} from "../../ProfilePicGroup"
import ScheduledDate from "../shared/layouts/ScheduledDate"
import {RecognitionRoutes} from "../../../enums/Routes"

const Image = styled.img`
  height: 60px;
  margin-bottom: 15px;
  width: auto;
`
interface Props extends InjectIntlProps {
  groupCelebration: GroupCelebration
  isMessageAdded?: boolean
}
const Details: React.FC<Props> = (props) => {
  const {groupCelebration, isMessageAdded = false} = props
  const {formatMessage} = useIntl()
  const greetingLabel = `${groupCelebration?.greeting?.label}, ${groupCelebration?.receiver.firstName} ${groupCelebration?.receiver.lastName}`
  const goToInvite = () => {
    tracking.recognitionCtaClick({
      source: "confirmation_modal",
      type: "greeting_card_invite_others"
    })
  }
  return (
    <Flex direction="column" justifyContent="center" alignItems="center" gap={2} height="100%">
      {!isMessageAdded && (
        <>
          <ProfilePicContainer>
            <CelebrationIcon src={groupCelebration?.greeting?.icon?.href} />
            <ProfilePicGroup
              users={[groupCelebration?.receiver]}
              outerWrapperSize={DEFAULT_MULTIPLE_PICTURE_SIZE}
              singlePictureSize={DEFAULT_MULTIPLE_PICTURE_SIZE}
            />
          </ProfilePicContainer>
          <H2 textAlign="center">
            <FormattedMessage id={greetingLabel} />
          </H2>
        </>
      )}
      {isMessageAdded && (
        <>
          <Image alt={formatMessage({id: "recognition.popup.createGroupCelebrationMessage.success.image"})} src={addMessageSuccess} />
          <H2>
            <FormattedMessage id="recognition.scheduledGroupCelebration.successMessage.header" />
          </H2>
        </>
      )}
      {groupCelebration.status === GroupCelebrationStatus.Scheduled && <ScheduledDate scheduledGroupCelebration={groupCelebration} />}
      {isMessageAdded && (
        <Body textAlign="center">
          <FormattedMessage id="recognition.scheduledCelebration.successMessage.body" />
        </Body>
      )}
      {groupCelebration.status === GroupCelebrationStatus.Active && <FormattedRelative value={groupCelebration.when} />}
      {groupCelebration.status === GroupCelebrationStatus.Scheduled && (
        <ButtonRouterLink to={`${RecognitionRoutes.ACCOUNT}/my-group-celebrations/invite`} cta onClick={goToInvite}>
          <FormattedMessage id="recognition.groupCelebration.actions.inviteOthers" />
        </ButtonRouterLink>
      )}
    </Flex>
  )
}
export default injectIntl(Details)
